import { baseUrlUser } from "../../../constants/url.constant";
import { Utils } from "../../common/views/Utils";
import { NewFeedPictureModel } from "../../newfeeds/models/NewFeedModel";
import { FileType } from "../../pictures/models/PictureModel";
import { PhotoDimension, PhotoSize } from "../models/PhotoCollageModel";

export class PhotoShapeManager {
    public width: number
    public dimension: PhotoDimension

    constructor(width: number) {
        this.width = width;
        this.dimension = new PhotoDimension(width);
    }

    public getSquare = (photo: NewFeedPictureModel, size: PhotoSize): JSX.Element => {
        return this.getRectangle(photo, size, size);
    }

    public getRectangle = (
        photo: NewFeedPictureModel,
        width: PhotoSize,
        height: PhotoSize,
        tall: boolean = true
    ): JSX.Element => {
        const w = tall ? width : height;
        const h = tall ? height : width;
        const spaceCount = tall && width === PhotoSize.oneThird ? 1 : 2;

        var url = "";

        if (photo.type === FileType.video) {
            url = "/dist/vendor/video.png";
        } else if (photo.type === FileType.others) {
            url = "/dist/vendor/file.png";
        } else {
            url = photo.imageUrl;
        }

        if (Utils.isValidUrl(baseUrlUser + url)) url = baseUrlUser + url;

        return <>
            <img
                className="center-cropped product-picture"
                width={this.getSizeValue(w, spaceCount)}
                height={this.getSizeValue(h)}
                alt=""
                src={url}
            />
        </>;
    }

    private getSizeValue = (size: PhotoSize, spaceCount: number = 2): number => {
        if (size === PhotoSize.oneThird) return this.dimension.getOneThird(spaceCount);
        else if (size === PhotoSize.half) return this.dimension.getHalf();
        else if (size === PhotoSize.twoThird) return this.dimension.getTwoThird();
        else if (size === PhotoSize.full) return this.dimension.width;
        else if (size === PhotoSize.extraFull) return this.dimension.getExtraWidth();

        return this.dimension.width;
    }
}